import React from "react";
import { IconBaseProps } from "react-icons";

export const createStyledIcon = <T extends {}>(IconComponent: any) =>
  IconComponent as React.ComponentType<
    T &
      React.HTMLAttributes<HTMLElement> & {
        size?: string | number;
        className?: string;
        onClick?: (e: React.MouseEvent) => void;
      }
  >;

export const createIcon = <T extends {}>(IconComponent: any) =>
  IconComponent as React.ComponentType<T>;

export const createIconElement = (IconComponent: any, props?: IconBaseProps) =>
  React.createElement(
    IconComponent as React.ComponentType<IconBaseProps>,
    props
  );
